import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Servizi from "@/pages/Servizi";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import LegalPage from "@/pages/LegalPage";
import PaymentSuccess from "@/pages/payment/PaymentSuccess";
import PaymentCancel from "@/pages/payment/PaymentCancel";

import PatientDashboard from "@/pages/patient/PatientDashboard";
import NuovaRichiesta from "@/pages/patient/NuovaRichiesta";
import MieRichieste from "@/pages/patient/MieRichieste";
import MiePrenotazioni from "@/pages/patient/MiePrenotazioni";
import Profilo from "@/pages/patient/Profilo";
import Assistenza from "@/pages/patient/Assistenza";

import ProDashboard from "@/pages/professional/ProDashboard";
import ProProfilo from "@/pages/professional/ProProfilo";
import Disponibilita from "@/pages/professional/Disponibilita";
import RichiesteRicevute from "@/pages/professional/RichiesteRicevute";
import Incarichi from "@/pages/professional/Incarichi";
import Pagamenti from "@/pages/professional/Pagamenti";
import Recensioni from "@/pages/professional/Recensioni";
import ProImpostazioni from "@/pages/professional/ProImpostazioni";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import GestioneUtenti from "@/pages/admin/GestioneUtenti";
import GestioneProfessionisti from "@/pages/admin/GestioneProfessionisti";
import GestioneServizi from "@/pages/admin/GestioneServizi";
import GestioneRichieste from "@/pages/admin/GestioneRichieste";
import GestionePrenotazioni from "@/pages/admin/GestionePrenotazioni";
import GestioneRecensioni from "@/pages/admin/GestioneRecensioni";
import AdminImpostazioni from "@/pages/admin/AdminImpostazioni";
import LogAttivita from "@/pages/admin/LogAttivita";

const PATIENT_ROLES = ["patient"];
const PRO_ROLES = ["professional"];
const ADMIN_ROLES = ["admin"];

const patient = (el) => <ProtectedRoute roles={PATIENT_ROLES}>{el}</ProtectedRoute>;
const pro = (el) => <ProtectedRoute roles={PRO_ROLES}>{el}</ProtectedRoute>;
const admin = (el) => <ProtectedRoute roles={ADMIN_ROLES}>{el}</ProtectedRoute>;

function NotFound() {
  return (
    <div className="min-h-screen bg-[#EAF3EF] flex flex-col items-center justify-center p-6 text-center">
      <h1 className="text-6xl font-extrabold text-[#087A73]">404</h1>
      <p className="text-[#5C6B68] mt-3 mb-6">Pagina non trovata.</p>
      <Link to="/" className="bg-[#087A73] text-white rounded-xl h-12 px-6 flex items-center font-semibold">Torna alla home</Link>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            {/* Patient */}
            <Route path="/paziente" element={patient(<PatientDashboard />)} />
            <Route path="/paziente/nuova-richiesta" element={patient(<NuovaRichiesta />)} />
            <Route path="/paziente/richieste" element={patient(<MieRichieste />)} />
            <Route path="/paziente/prenotazioni" element={patient(<MiePrenotazioni />)} />
            <Route path="/paziente/profilo" element={patient(<Profilo />)} />
            <Route path="/paziente/assistenza" element={patient(<Assistenza />)} />

            {/* Professional */}
            <Route path="/pro" element={pro(<ProDashboard />)} />
            <Route path="/pro/profilo" element={pro(<ProProfilo />)} />
            <Route path="/pro/disponibilita" element={pro(<Disponibilita />)} />
            <Route path="/pro/richieste" element={pro(<RichiesteRicevute />)} />
            <Route path="/pro/incarichi" element={pro(<Incarichi />)} />
            <Route path="/pro/pagamenti" element={pro(<Pagamenti />)} />
            <Route path="/pro/recensioni" element={pro(<Recensioni />)} />
            <Route path="/pro/impostazioni" element={pro(<ProImpostazioni />)} />

            {/* Admin */}
            <Route path="/admin" element={admin(<AdminDashboard />)} />
            <Route path="/admin/utenti" element={admin(<GestioneUtenti />)} />
            <Route path="/admin/professionisti" element={admin(<GestioneProfessionisti />)} />
            <Route path="/admin/servizi" element={admin(<GestioneServizi />)} />
            <Route path="/admin/richieste" element={admin(<GestioneRichieste />)} />
            <Route path="/admin/prenotazioni" element={admin(<GestionePrenotazioni />)} />
            <Route path="/admin/recensioni" element={admin(<GestioneRecensioni />)} />
            <Route path="/admin/impostazioni" element={admin(<AdminImpostazioni />)} />
            <Route path="/admin/log" element={admin(<LogAttivita />)} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
